module.exports = __webpack_public_path__ + "img/eg.ffd2c5a5.svg";